export enum ComplianceStateEnum {
    NotAssessed = 0,
    Compliant = 1,
    NonCompliant = 2,
    Uncertain = 3,
}

export interface ComplianceStateDisplay {
    label: string;
    color: string;
    icon: string;
}

export const ComplianceStateDisplayMap: Record<ComplianceStateEnum, ComplianceStateDisplay | null> = {
    [ComplianceStateEnum.NotAssessed]: null,
    [ComplianceStateEnum.Compliant]: {
        label: 'Compliant',
        color: '#01BD79',
        icon: 'assets/images/green-check.svg',
    },
    [ComplianceStateEnum.NonCompliant]: {
        label: 'Non Compliant',
        color: '#E74C3C',
        icon: 'assets/images/red-check.svg',
    },
    [ComplianceStateEnum.Uncertain]: {
        label: 'Uncertain',
        color: '#E67E22',
        icon: 'assets/images/Exception-Status.svg',
    },
};
